"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[416],{

/***/ 92408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_BusinessGoals; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/BusinessGoals/businessGoals.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 15.4375rem;\n    padding-top: 6.5625rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    flex-direction: row;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    order: 1;\n    width: 60%;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    order: 2;\n    max-width: 29.25rem;\n    margin-bottom: -4em;\n    align-self: unset;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    order: 2;\n    width: 50%;\n    margin-bottom: 0;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 35.625rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    letter-spacing: -0.0125rem;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 31.5625rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 2.5rem;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}




const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e1iucvyh0"
})("position:relative;overflow-x:hidden;", mixins/* defaultContainerSize */.sX, ";margin:0;max-width:100%;background:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";padding-top:4rem;padding-bottom:18.3125rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");
const GoalsInner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1iucvyh1"
})("width:100%;max-width:77.125rem;margin:0 auto;display:flex;flex-direction:column;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const GoalsTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1iucvyh2"
})("order:1;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";");
const GoalsImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1iucvyh3"
})("order:1;margin-bottom:2rem;height:100%;width:100%;max-width:29.25rem;max-height:27.5rem;align-self:flex-end;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";img{width:100%;height:100%;}");
const GoalsTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1iucvyh4"
})(Typography/* Headline1 */.iH, ";margin:0 0 2rem 0;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";");
const GoalsTitlePrimary = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1iucvyh5"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";");
const GoalsTitleWhite = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1iucvyh6"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";");
const GoalsPoint = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1iucvyh7"
})(Typography/* ParagraphS */.fw, ";max-width:31.5625rem;display:flex;flex-direction:row;letter-spacing:0.0125rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";margin:0 0 2rem 0;&:not(:last-child){margin:0 0 2rem 0;}", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";");
const GoalsPointCheckmark = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1iucvyh8"
})("margin-right:1.5rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), ";");

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
;// CONCATENATED MODULE: ./components/sections/BusinessGoals/BusinessGoals.tsx





const BusinessGoals = (param)=>{
    let { data , titleAs  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GoalsInner, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GoalsTextWrapper, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GoalsTitle, {
                            as: titleAs,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoalsTitlePrimary, {
                                    children: data.title
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoalsTitleWhite, {
                                    children: data.title2
                                })
                            ]
                        }),
                        data.points.map((point, index)=>{
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GoalsPoint, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoalsPointCheckmark, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                            width: "21",
                                            height: "16",
                                            viewBox: "0 0 21 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    d: "M20.588 2.52266L7.57807 16L0.383143 8.56185C0.130978 8.28171 -0.00630293 7.91119 0.000222409 7.52835C0.00674775 7.1455 0.15657 6.78022 0.418124 6.50947C0.679679 6.23872 1.03255 6.08362 1.40238 6.07687C1.77222 6.07011 2.13015 6.21222 2.40077 6.47326L7.57807 11.8228L18.5703 0.434072C18.7069 0.291552 18.8703 0.179551 19.0504 0.104991C19.2304 0.0304314 19.4233 -0.00510121 19.6172 0.000590008C19.9771 0.0100618 20.319 0.165775 20.5689 0.434072C20.7037 0.569298 20.8112 0.730873 20.8852 0.90943C20.9592 1.08799 20.9982 1.27997 20.9999 1.47425C21.0017 1.66853 20.9662 1.86125 20.8955 2.04121C20.8248 2.22118 20.7202 2.38483 20.588 2.52266Z",
                                                    fill: "url(#paint0_linear_5506_27551)"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                                                        id: "paint0_linear_5506_27551",
                                                        x1: "0",
                                                        y1: "15.9994",
                                                        x2: "19.6484",
                                                        y2: "15.9994",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                                                stopColor: "#0E4ED7"
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                                                offset: "1",
                                                                stopColor: "#F94743"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    prismic_reactjs.RichText.asText(point.business_goal)
                                ]
                            }, index);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoalsImageWrapper, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        ...(0,imageSerializer/* imageSerializer */.l)(data.image, {
                            inset: null
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/BusinessGoals/index.ts

/* harmony default export */ var sections_BusinessGoals = (BusinessGoals);


/***/ })

}]);